import { Dtos, type SuretyAccountId } from "@inrev/common";
import { useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { retiredProConsQueryKey } from "../decisioning.keys";

export const useFetchRetiredProCons = (accountId: SuretyAccountId) => {
	const { get } = useRequest();

	const query = useQuery({
		queryKey: retiredProConsQueryKey(accountId),
		meta: { suppressErrorModal: true },
		queryFn: async () =>
			Dtos.Decisioning.ProCon.Get.Response.schema
				.array()
				.parse(await get<unknown>(`/v2/admin/surety/accounts/${accountId}/pro-cons/retired`)),
	});

	return {
		retiredProCons: query.data,
		retiredProConsIsLoading: query.isLoading,
		retiredProConsError: query.error,
		refetchRetiredProCons: query.refetch,
	};
};
